window.app = window.app || {};

window.app.countdowns = {
  el: {
    countdowns: document.querySelectorAll('.mt-countdown'),
  },

  init: function () {
    const _this = this;
    if (!_this.el.countdowns) return;

    _this.el.countdowns.forEach((countdown) => {
      const countdownDate = new Date(countdown.dataset.countdown);
      setInterval(() => { _this.updateCountdown(countdown, countdownDate); }, 1000);
    });
  },

  updateCountdown: function (countdown, countdownDate) {
    const currentDate = new Date();
    const targetDateInUserTimezone = countdownDate.toLocaleString('en-US', { timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone });
    const timeleft = Math.floor((new Date(targetDateInUserTimezone) - currentDate) / 1000);
    const days = Math.floor(timeleft / 86400);
    const hours = Math.floor((timeleft % 86400) / 3600);
    const minutes = Math.floor((timeleft % 3600) / 60);
    const seconds = Math.floor(timeleft % 60);
    let counterHtml = '';
    if (timeleft > 0) {
      (days > 0) && (counterHtml += `<span data-days><strong>${(days < 10) ? '0' : ''}${days}</strong> days</span>`);
      (hours > 0) && (counterHtml += `<span data-hours><strong>${(hours < 10) ? '0' : ''}${hours}</strong> hours</span>`);
      counterHtml += `<span data-mins><strong>${(minutes < 10) ? '0' : ''}${minutes}</strong> min.</span>`;
      counterHtml += `<span data-secs><strong>${(seconds < 10) ? '0' : ''}${seconds}</strong> sec.</span>`;
    }
    countdown.innerHTML = counterHtml;
  },
};

window.app.countdowns.init();